import BaseService from '../common/BaseService';
import { DASHBOARD_MODELS_LITE, PARTNER_BROKER } from '../common/endpoints';

export default class DashboardLiteService extends BaseService {
    constructor(props) {
        super(props);
    }

    fetchDashboardModelsLite() {
        return this.client.get(DASHBOARD_MODELS_LITE).then(response => response.data);
    }

    fetchPartnerBroker(replacements) {
        return this.client.get(PARTNER_BROKER, { replacements }).then(response => response.data && response.data.payload);
    }
}